import React from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
/* Example of button filter
{
  genericRadioFilter({
    content: [
      {
          option: 'all',
          id: 'all-radio-filter',
          name: 'statusFilterRadios',
          labelName: 'all',
      },
      {
          option: 'open',
          id: 'open-radio-filter',
          name: 'statusFilterRadios',
          labelName: 'open',
      }
    ],
    value: 'open',
    handleOnClick: this.handleOnClick,
    type: 'buttons',
  })
}
*/

/* Example of generic filter
{
  genericRadioFilter({
    content: [
      {
          option: 'all',
          id: 'all-radio-filter',
          name: 'statusFilterRadios',
          labelName: 'all',
          className: 'col-xs-2 all-class',
      },
      {
          option: 'open',
          id: 'open-radio-filter',
          name: 'statusFilterRadios',
          labelName: 'open',
          className: 'col-xs-2 open-class',
      }
    ],
    value: 'open',
    handleOnClick: this.handleOnClick,
    title: 'search-product-by',
    label: true,
    labelClassName: 'col-xs-4 search-by-max-width',
  })
}
*/
const renderSections = (content, type, inputNode, value, handleOnClick) => {
  const sections = [];
  if (type === 'buttons') {
    content.map((props) => {
      sections.push(
        <Button bsStyle={getBsStyle(props.option, value)} style={{ marginLeft: (isAFM && props && props.labelName === 'order') ? '130px' : '5px', ...props.style }}>
          <div className="radio">
            <label htmlFor={props.id}>
              <input
                {...inputNode}
                id={props.id}
                name={props.name}
                type="radio"
                value={props.option}
                checked={props.option === value}
                onClick={() => { handleOnClick(props.option); }}
              />
              <Translate value={props.labelName} />
            </label>
          </div>
        </Button>
      );
    });
  } else {
    content.map((props) => {
      sections.push(
        <label htmlFor={props.id} className={props.className}>
          <input
            {...inputNode}
            id={props.id}
            name={props.name}
            type="radio"
            value={props.option}
            checked={props.option === value}
            onClick={() => { handleOnClick(props.option); }}
          />
          <Translate value={props.labelName} />
        </label>,
      );
    });
  }
  return sections;
};

const genericRadioFilter = props => (
  (props.type === 'buttons') ?
    <ButtonToolbar className="radio-filter-buttons">
      {renderSections(props.content, props.type, props.input, props.value, props.handleOnClick)}
    </ButtonToolbar> :
    <div className="form-group" id="search-product-by" style={{ paddingBottom: '10px' }}>
      {(props.label) ?
        <label className={props.labelClassName}>
          <Translate value={props.title} />:
        </label> :
        ''
      }
      {renderSections(props.content, props.type, props.input, props.value, props.handleOnClick)}
    </div>
);

genericRadioFilter.defaultProps = {
  type: 'generic',
  label: false,
  labelClassName: '',
  title: '',
};

genericRadioFilter.propTypes = {
  input: React.PropTypes.node.isRequired,
  handleOnClick: React.PropTypes.func.isRequired,
  content: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  value: React.PropTypes.string.isRequired,
  title: React.PropTypes.string,
  type: React.PropTypes.string,
  label: React.PropTypes.bool,
  labelClassName: React.PropTypes.string,
};

export default genericRadioFilter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/genericRadioFilter.jsx